<ps-ui-modal>
  <span psUiModalTitle class="title-modal">
    {{ modalTitle }}
  </span>
  <ps-ui-modal-body class="modal-content-body">
    {{ modalmessage }}
    <ul *ngFor="let id of buyerQuotaIds; &quot;list-style-type&quot;">
      <li>
        {{ id }}
      </li>
    </ul>
  </ps-ui-modal-body>
</ps-ui-modal>
